/**
 * Localization Modal Manager - Moon Moon Agency
 * Ouvre/ferme la modale de selection pays / langue (liens crawlables).
 * Declenchee par [data-localization-modal-open] (footer, header, menu mobile).
 * Le clic sur une option est intercepte par le custom element <localization-form>
 * (mm_language_selector.js) qui soumet le form 'localization'.
 */

/*********************************************************************************************
 * 🌍 LOCALIZATION MODAL MANAGER
 */
const LocalizationModalManager = {
	config: {
		selectors: {
			open: '[data-localization-modal-open]',
			close: '[data-localization-modal-close]',
			modal: '[data-localization-modal]',
			closeButton: '.mm-localization-modal__close',
		},
		classes: {
			open: 'mm-open',
		},
	},

	trapId: null,

	init() {
		this.modal = window.getElement(this.config.selectors.modal);
		if (!this.modal) return; // Guard : modale absente du DOM

		this._bindEvents();
		window.log('info', '🌍 [LOCALIZATION_MODAL]', 'Initialized');
	},

	_bindEvents() {
		document.addEventListener('click', (e) => {
			const opener = e.target.closest(this.config.selectors.open);
			if (opener) {
				e.preventDefault();
				this.open(opener);
				return;
			}

			if (e.target.closest(this.config.selectors.close)) {
				this.close();
			}
		});
	},

	open(trigger) {
		if (!this.modal) return;

		this.modal.removeAttribute('hidden');
		// Reflow pour permettre la transition d'ouverture
		void this.modal.offsetWidth;
		this.modal.classList.add(this.config.classes.open);

		window.lockScroll();

		const closeButton = this.modal.querySelector(this.config.selectors.closeButton);
		this.trapId = window.FocusTrapManager?.activate(this.modal, {
			trigger,
			onEscape: () => this.close(),
			initialFocus: closeButton,
		});

		window.emit('global:localization-modal-opened');
		window.log('info', '🌍 [LOCALIZATION_MODAL]', 'Opened');
	},

	close() {
		if (!this.modal) return;

		this.modal.classList.remove(this.config.classes.open);
		window.unlockScroll();

		if (this.trapId) {
			window.FocusTrapManager?.deactivate(this.trapId);
			this.trapId = null;
		}

		// Masquer apres la transition de fermeture (fallback timeout si pas de transitionend)
		const hide = () => {
			if (!this.modal.classList.contains(this.config.classes.open)) {
				this.modal.setAttribute('hidden', '');
			}
		};
		this.modal.addEventListener('transitionend', hide, { once: true });
		setTimeout(hide, 400);

		window.emit('global:localization-modal-closed');
		window.log('info', '🌍 [LOCALIZATION_MODAL]', 'Closed');
	},
};

// Auto-init avec verification readyState
if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', () => LocalizationModalManager.init());
} else {
	LocalizationModalManager.init();
}
